import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {CurrencyObject} from '../models/currency';


export const currencyActionTypes = {
  LOAD: type('[currency] Load'),
  LOAD_SUCCESS: type('[currency] Load Success'),
  LOAD_FAIL: type('[currency] Load Fail'),
};

export class LoadCurrencyAction implements Action {
  readonly type = currencyActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadCurrencySuccessAction implements Action {
  readonly type = currencyActionTypes.LOAD_SUCCESS;
  constructor(public payload?: CurrencyObject[]) {}
}

export class LoadCurrencyFailAction implements Action {
  readonly type = currencyActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

